<div (clickOutside)="showResultsTemplate = false">
  <div
    class="relative flex w-full min-w-[19rem] max-w-xl cursor-pointer items-center justify-center gap-0"
  >
    @if (hasSearchFields()) {
      <select
        [disabled]="disabled()"
        class="shrink-0 !rounded-r-none pr-8"
        (ngModelChange)="onFieldChangeEvent($event)"
        [ngModel]="localSearchField()"
      >
        @if (showAllFieldsOption()) {
          <option value="all">All fields</option>
        }
        @for (field of searchFields(); track field) {
          <option [value]="isSimpleType(field) ? field : field.name">
            @if (isSimpleType(field)) {
              {{ field | humanize }}
            } @else if (hasDisplayName(field)) {
              {{ field.displayName }}
            } @else {
              {{ field.name | humanize }}
            }
          </option>
        }
      </select>
    }
    <div class="relative flex grow items-center">
      <svg-icon
        class="pointer-events-none absolute left-2 top-1/2 -translate-y-1/2 text-french-blue-600"
        src="/assets/icons/general/search.svg"
      />
      <input
        [class.!rounded-l-none]="hasSearchFields()"
        class="grow !pl-8"
        type="search"
        [placeholder]="placeholder() | sentenceCase"
        [disabled]="disabled()"
        autocomplete="on"
        (keyup)="onEnterPressEvent($event)"
        [ngModel]="localSearchTerm()"
        (ngModelChange)="onModelChangeEvent($event)"
      />
    </div>
    @if (showResults()) {
      <ng-container *ngTemplateOutlet="searchResults" />
    }
  </div>
</div>

<ng-template #searchResults>
  @if (showResults() && showResultsTemplate && localSearchTerm().length) {
    <div
      class="absolute left-0 top-full z-50 my-1 w-full overflow-hidden rounded-lg bg-white p-2 shadow-xl"
    >
      <div class="max-h-[350px] overflow-auto">
        @if (isLoading()) {
          <div class="grid place-items-center p-10">
            <ag1-loader />
          </div>
        }
        @if (!isLoading()) {
          <div class="space-y-1">
            <p class="font-semibold">
              Search results for "{{ localSearchTerm() }}"
            </p>
            <ng-container *ngTemplateOutlet="customResultsRef()" />
          </div>
        }
      </div>
    </div>
  }
</ng-template>
